import * as React from "react";
import CenteredNotification from "./CenteredNotification";
import { Spinner } from "@/components/ui/spinner";

export default function Progress(props: React.PropsWithChildren<{}>) {
    return (
        <CenteredNotification>
            <div className="flex flex-col items-center gap-4 py-8">
                <Spinner className="h-8 w-8 text-primary" />
                {props.children && (
                    <p className="text-sm font-medium text-muted-foreground">
                        {props.children}
                    </p>
                )}
            </div>
        </CenteredNotification>
    );
}
